// extracted by mini-css-extract-plugin
module.exports = {"darkPurple":"#6B6F8F"};